import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme"; 
import { 
    Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, 
    Pagination, TextField, Card, CardContent, Typography, Stack, Chip, TableContainer, 
    CircularProgress, IconButton, Grid, InputAdornment, Tabs, Tab, Autocomplete
} from "@mui/material";
import { 
    LocalOfferOutlined, AddCircleOutline, EditOutlined, DeleteOutline, ShuffleOutlined, PersonOutline, SearchOutlined 
} from "@mui/icons-material";
import swal from "sweetalert";
import { t } from "i18next";
import axios from "axios";
import React, { useEffect, useState } from "react";

const metronicTheme = createTheme({
    palette: {
        background: { default: "#F5F8FA", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#7E8299" }, 
        primary: { main: "#1B84FF", light: "#F1FAFF" },
        success: { main: "#50CD89", light: "#E8FFF3" },
        danger: { main: "#F1416C", light: "#FFF5F8" },
        warning: { main: "#FFC700", light: "#FFF8DD" },
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: { styleOverrides: { root: { borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.03)", border: "1px solid #E4E6EF" } } },
        MuiTableCell: { styleOverrides: { root: { borderBottom: "1px solid #EFF2F5 !important", padding: "14px 12px", color: "#3F4254", fontSize: "0.85rem", fontFamily: "'Plus Jakarta Sans', sans-serif !important" } } },
        MuiButton: { styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif", textTransform: 'none' } } },
        MuiTab: { styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif", textTransform: 'none', fontSize: '1rem', minHeight: '54px' } } }
    }
});

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

function Promo() {
    const [load, setLoad] = useState(true);
    const [isShow, setShow] = useState(false);
    
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 15;

    const [promo, setPromo] = useState(null);
    const [promoList, setPromoList] = useState([]);
    const [promoCode, setPromoCode] = useState("");
    
    // State dữ liệu User để tìm kiếm
    const [users, setUsers] = useState([]);
    const [selectedUserCreate, setSelectedUserCreate] = useState(null); 
    const [selectedUserEdit, setSelectedUserEdit] = useState(null); 
    const [searchUserFilter, setSearchUserFilter] = useState(""); 

    const [tabValue, setTabValue] = useState(0);

    // ==========================================
    // LẤY DỮ LIỆU KHUYẾN MÃI & USER
    // ==========================================
    useEffect(() => {
        if (load === true) {
            axios.get(`${process.env.REACT_APP_API_URL}/promo/get?page=${page}&limit=${limit}`)
                .then((res) => {
                    if (res.data.success) {
                        setPromoList(res.data.data);
                        setTotalPages(res.data.totalPages || 1); 
                    }
                    setLoad(false);
                }).catch(() => setLoad(false));
                
            axios.get(`${process.env.REACT_APP_API_URL}/auth/getall`)
                .then((res) => {
                    if (res.data && res.data.success) {
                        const allOption = { username: "all", name: "Tất cả mọi người" };
                        setUsers([allOption, ...res.data.data]);
                    }
                }).catch(err => console.log(err));
        }
    }, [load, page]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setLoad(true); 
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleGenerateRandomCode = () => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let result = '';
        for (let i = 0; i < 8; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        setPromoCode(result);
    };

    // ==========================================
    // XỬ LÝ FORM TẠO & SỬA
    // ==========================================
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoad(true); 
        const formData = {
            code: promoCode, 
            num: Number(e.target.num.value),
            money: Number(e.target.money.value),
            username: selectedUserCreate ? selectedUserCreate.username : "all"
        };
        axios.post(`${process.env.REACT_APP_API_URL}/promo/create`, formData)
            .then((res) => {
                swal(t('success'), "Tạo mã khuyến mãi thành công!", "success").then(() => {
                    setPage(1); 
                    setLoad(true);
                    setPromoCode(""); 
                    setSelectedUserCreate(null); 
                    e.target.reset(); 
                });
            })
            .catch(() => {
                swal(t("error"), "Mã đã tồn tại hoặc có lỗi xảy ra", "error");
                setLoad(false);
            });
    };

    const handleSubmitnotify = (e) => {
        e.preventDefault();
        setLoad(true);
        const formData = {
            id: promo._id,
            code: e.target.code.value,
            num: Number(e.target.num.value),
            money: Number(e.target.money.value),
            username: selectedUserEdit ? selectedUserEdit.username : "all"
        };

        axios.post(`${process.env.REACT_APP_API_URL}/promo/edit`, formData).then((res) => {
            swal(t('success'), "Cập nhật thành công!", "success").then(() => {
                setLoad(true);
                setShow(false);
            });
        }).catch(() => {
            swal(t("error"), "Có lỗi xảy ra", "error");
            setLoad(false);
        });
    };

    // ==========================================
    // LỌC DANH SÁCH (TABS & THANH TÌM KIẾM)
    // ==========================================
    const filteredList = promoList ? promoList.filter(item => {
        const isAll = !item.username || item.username.toLowerCase() === 'all';
        let matchTab = true;
        if (tabValue === 0) matchTab = isAll;
        if (tabValue === 1) matchTab = !isAll;

        let matchSearch = true;
        if (searchUserFilter.trim() !== "") {
            const searchLower = searchUserFilter.toLowerCase().trim();
            const usernameLower = item.username ? item.username.toLowerCase() : "";
            matchSearch = usernameLower.includes(searchLower);
        }

        return matchTab && matchSearch;
    }) : [];

    // ==========================================
    // STYLES ĐÃ FIX LỖI GIAO DIỆN CHỮ BỊ DÍNH
    // ==========================================
    const tableHeadSx = {
        color: "#A1A5B7 !important", fontWeight: "800 !important", fontSize: "0.75rem !important", 
        backgroundColor: "#FFFFFF !important", borderBottom: "2px solid #EFF2F5 !important",
        textTransform: "uppercase !important"
    };

    const textFieldSx = {
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px', 
            backgroundColor: '#F9F9F9', 
            height: '46px',
            padding: '0', // Xóa padding mặc định của vỏ để input bên trong tự lo khoảng lề
            '& fieldset': { borderColor: '#E4E6EF' },
            '&:hover fieldset': { borderColor: '#B5B5C3' },
            '&.Mui-focused fieldset': { borderColor: '#1B84FF', borderWidth: '1px' },
        },
        '& .MuiInputBase-input': { 
            padding: '0 14px !important', // FIX LỖI: Tạo lề 14px cho cả trái và phải của chữ
            height: '100%',
            boxSizing: 'border-box',
            fontSize: '0.95rem', 
            color: '#181C32', 
            fontWeight: 600
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <ThemeProvider theme={metronicTheme}>
                    <style>{`
                        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                        .safe-promo-zone * { font-family: 'Plus Jakarta Sans', sans-serif !important; }
                    `}</style>

                    <Box className="safe-promo-zone" component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: 'background.default', minHeight: 'calc(100vh - 70px)', position: "relative" }}>
                        
                        {load && (
                            <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' }}>
                                <CircularProgress size={50} sx={{ color: '#1B84FF' }} />
                            </Box>
                        )}

                        <Container maxWidth="xl">
                            
                            <Box mb={4} display="flex" alignItems="center" gap={1.5}>
                                <LocalOfferOutlined sx={{ fontSize: '2.5rem', color: '#1B84FF' }} />
                                <Box>
                                    <Typography variant="h5" fontWeight="800" color="#181C32">Quản Lý Giftcode</Typography>
                                    <Typography variant="body2" color="text.secondary">Thiết lập mã khuyến mãi chung và giám sát mã cá nhân</Typography>
                                </Box>
                            </Box>

                            {/* FORM THÊM MỚI */}
                            <Card sx={{ mb: 4, backgroundColor: '#FFFFFF' }}>
                                <CardContent sx={{ p: 3 }}>
                                    <Typography variant="subtitle1" fontWeight="800" color="#181C32" mb={3} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <AddCircleOutline color="primary" /> TẠO MÃ KHUYẾN MÃI MỚI
                                    </Typography>
                                    <form onSubmit={handleSubmit}>
                                        <Grid container spacing={2.5} alignItems="flex-end">
                                            <Grid item xs={12} sm={6} md={3}>
                                                <Typography variant="caption" fontWeight="800" color="#7E8299" mb={1} display="block" textTransform="uppercase" sx={{ height: '18px' }}>
                                                    {t("code_promo")}
                                                </Typography>
                                                <TextField 
                                                    fullWidth name="code" id="code" required placeholder="" 
                                                    sx={{...textFieldSx, '& .MuiInputBase-input': { ...textFieldSx['& .MuiInputBase-input'], textTransform: 'uppercase' }}} 
                                                    value={promoCode}
                                                    onChange={(e) => setPromoCode(e.target.value.toUpperCase())}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end" sx={{ pr: 1.5 }}>
                                                                <IconButton onClick={handleGenerateRandomCode} edge="end" color="primary" title="Tạo ngẫu nhiên" sx={{ backgroundColor: '#F1FAFF', borderRadius: '6px', width: '32px', height: '32px' }}>
                                                                    <ShuffleOutlined fontSize="small" />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={2}>
                                                <Typography variant="caption" fontWeight="800" color="#7E8299" mb={1} display="block" textTransform="uppercase" sx={{ height: '18px' }}>{t("code_uses")}</Typography>
                                                <TextField fullWidth name="num" id="num" type="number" required placeholder="" sx={{...textFieldSx, '& .MuiInputBase-input': { ...textFieldSx['& .MuiInputBase-input'], textTransform: 'none' }}} />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={2.5}>
                                                <Typography variant="caption" fontWeight="800" color="#7E8299" mb={1} display="block" textTransform="uppercase" sx={{ height: '18px' }}>{t("money")}</Typography>
                                                <TextField fullWidth name="money" id="money" type="number" required placeholder="" sx={{...textFieldSx, '& .MuiInputBase-input': { ...textFieldSx['& .MuiInputBase-input'], textTransform: 'none' }}} />
                                            </Grid>
                                            
                                            <Grid item xs={12} sm={6} md={2.5}>
                                                <Typography variant="caption" fontWeight="800" color="#7E8299" mb={1} textTransform="uppercase" sx={{ display: 'flex', alignItems: 'center', gap: 0.5, height: '18px' }}>
                                                    <PersonOutline sx={{ fontSize: '1.1rem' }} /> USER ĐƯỢC NHẬN
                                                </Typography>
                                                <Autocomplete
                                                    options={users}
                                                    getOptionLabel={(option) => option.username === 'all' ? 'Tất cả mọi người (all)' : `${option.username} - ${option.name}`}
                                                    value={selectedUserCreate}
                                                    onChange={(event, newValue) => { setSelectedUserCreate(newValue); }}
                                                    sx={{
                                                        // Bổ sung lề phải để tránh icon dính vào text, text tự đẩy bằng lề của input
                                                        '& .MuiOutlinedInput-root': { paddingRight: '39px !important' }
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField 
                                                            {...params} 
                                                            placeholder="" 
                                                            sx={{...textFieldSx, '& .MuiInputBase-input': { ...textFieldSx['& .MuiInputBase-input'], textTransform: 'none' }}}
                                                        />
                                                    )}
                                                    componentsProps={{ paper: { sx: { borderRadius: '8px', mt: 1, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', '& .MuiAutocomplete-listbox': { fontSize: '0.9rem', fontWeight: 600 } } } }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2}>
                                                <Button type="submit" variant="contained" color="primary" fullWidth sx={{ height: '46px', fontWeight: 800, borderRadius: '8px', boxShadow: 'none' }}>
                                                    {t("add_new")}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </CardContent>
                            </Card>

                            {/* BẢNG DANH SÁCH & TABS */}
                            <Card sx={{ backgroundColor: '#FFFFFF' }}>
                                <Box display="flex" alignItems="center" justifyContent="space-between" pr={3}>
                                    <Tabs 
                                        value={tabValue} 
                                        onChange={handleTabChange} 
                                        sx={{ borderBottom: 1, borderColor: '#EFF2F5', px: 2, pt: 1, '& .Mui-selected': { color: '#1B84FF !important', fontWeight: '800 !important' } }}
                                        TabIndicatorProps={{ style: { backgroundColor: '#1B84FF', height: '3px', borderTopLeftRadius: '3px', borderTopRightRadius: '3px' } }}
                                    >
                                        <Tab label="Mã Chung" />
                                        <Tab label="Mã Cá Nhân" />
                                    </Tabs>

                                    <TextField 
                                        placeholder="Tìm theo user..." 
                                        size="small"
                                        value={searchUserFilter}
                                        onChange={(e) => setSearchUserFilter(e.target.value)}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start" sx={{ pl: 1 }}>
                                                    <SearchOutlined fontSize="small" sx={{ color: '#A1A5B7' }} />
                                                </InputAdornment>
                                            )
                                        }}
                                        sx={{ 
                                            width: '250px',
                                            '& .MuiOutlinedInput-root': { borderRadius: '8px', height: '38px', backgroundColor: '#F9F9F9', '& fieldset': { borderColor: '#E4E6EF' }, '&:hover fieldset': { borderColor: '#B5B5C3' }, '&.Mui-focused fieldset': { borderColor: '#1B84FF' } },
                                            '& .MuiInputBase-input': { fontSize: '0.85rem', fontWeight: 600, height: '100%' }
                                        }}
                                    />
                                </Box>

                                <TableContainer sx={{ overflowX: 'auto' }}>
                                    <Table sx={{ minWidth: 1460 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{...tableHeadSx, pl: 3}}>{t("code_promo")}</TableCell>
                                                <TableCell sx={tableHeadSx}>ĐỐI TƯỢNG NHẬN</TableCell>
                                                <TableCell sx={tableHeadSx}>ĐÃ DÙNG / TỔNG</TableCell>
                                                <TableCell sx={tableHeadSx}>{t("money")} (GIÁ TRỊ)</TableCell>
                                                <TableCell align="right" sx={{...tableHeadSx, pr: 3}}>{t("more")}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filteredList && filteredList.length > 0 ? (
                                                filteredList.map((item) => {
                                                    const maxCount = item.max || item.num || 0; 
                                                    const currentNum = item.num || 0;
                                                    const usedCount = maxCount - currentNum; 
                                                    const isSoldOut = currentNum <= 0;
                                                    const isAll = !item.username || item.username.toLowerCase() === 'all';

                                                    return (
                                                        <TableRow key={item._id} hover sx={{ verticalAlign: 'middle' }}>
                                                            <TableCell sx={{ pl: 3 }}>
                                                                <Typography variant="body2" fontWeight="800" color="#2563EB">
                                                                    {item.code}
                                                                </Typography>
                                                            </TableCell>

                                                            <TableCell>
                                                                {isAll ? (
                                                                    <Chip label="Tất cả mọi người" size="small" sx={{ backgroundColor: '#F8F5FF', color: '#7239EA', fontWeight: 700, borderRadius: '6px' }} />
                                                                ) : (
                                                                    <Chip label={item.username} size="small" sx={{ backgroundColor: '#FFF8DD', color: '#B58D00', fontWeight: 700, borderRadius: '6px' }} />
                                                                )}
                                                            </TableCell>

                                                            <TableCell>
                                                                <Chip label={`${usedCount} / ${maxCount}`} size="small" sx={{ backgroundColor: isSoldOut ? '#FFF5F8' : '#E8FFF3', color: isSoldOut ? '#F1416C' : '#16A34A', fontWeight: 800, borderRadius: '6px' }} />
                                                                {isSoldOut && <Typography variant="caption" color="error" sx={{ml: 1, fontWeight: 700}}>Đã hết!</Typography>}
                                                            </TableCell>

                                                            <TableCell>
                                                                <Typography variant="body2" fontWeight="800" color="#181C32">
                                                                    {item.money?.toLocaleString("vi-VN")} đ
                                                                </Typography>
                                                            </TableCell>
                                                            
                                                            <TableCell align="right" sx={{ pr: 3 }}>
                                                                <Stack direction="row" spacing={1} justifyContent="flex-end">
                                                                    <IconButton size="small" onClick={() => { 
                                                                        setPromo(item); 
                                                                        const matchedUser = users.find(u => u.username === (item.username || "all"));
                                                                        setSelectedUserEdit(matchedUser || null);
                                                                        setShow(true); 
                                                                    }} sx={{ color: '#1B84FF', backgroundColor: '#F1FAFF', borderRadius: '8px', '&:hover': { backgroundColor: '#1B84FF', color: '#FFF' } }}>
                                                                        <EditOutlined fontSize="small" />
                                                                    </IconButton>
                                                                    <IconButton size="small" onClick={() => {
                                                                        swal({
                                                                            title: "Xóa mã này?", text: "Hành động này không thể hoàn tác!", icon: "warning",
                                                                            buttons: ["Hủy", "Xóa Ngay"], dangerMode: true,
                                                                        }).then((willDelete) => {
                                                                            if (willDelete) {
                                                                                setLoad(true);
                                                                                axios.post(`${process.env.REACT_APP_API_URL}/promo/delete`, { id: item._id })
                                                                                    .then(() => { swal(t("success"), "", "success"); setLoad(true); })
                                                                                    .catch(() => setLoad(false));
                                                                            }
                                                                        });
                                                                    }} sx={{ color: '#F1416C', backgroundColor: '#FFF5F8', borderRadius: '8px', '&:hover': { backgroundColor: '#F1416C', color: '#FFF' } }}>
                                                                        <DeleteOutline fontSize="small" />
                                                                    </IconButton>
                                                                </Stack>
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center" sx={{ py: 6, color: '#A1A5B7', fontWeight: 700 }}>
                                                        Không tìm thấy mã khuyến mãi nào phù hợp.
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                
                                {totalPages > 1 && (
                                    <Box sx={{ p: 2, display: "flex", justifyContent: "center", borderTop: '1px solid #EFF2F5' }}>
                                        <Pagination color="primary" shape="rounded" page={page} count={totalPages} size="small" onChange={handleChangePage} sx={{ '& .MuiPaginationItem-root': { fontWeight: 700 } }} />
                                    </Box>
                                )}
                            </Card>
                        </Container>
                    </Box>

                    {/* MODAL CHỈNH SỬA MÃ */}
                    {isShow && promo != null && (
                        <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(3px)' }}>
                            <Card sx={{ width: '450px', p: 3 }}>
                                <Typography variant="h6" fontWeight="800" mb={1} color="#181C32">
                                    {t("edit")} Mã Khuyến Mãi
                                </Typography>
                                <Typography variant="body2" color="text.secondary" mb={3}>
                                    Mã đang chọn: <Typography component="span" fontWeight="800" color="#1B84FF">{promo.code}</Typography>
                                </Typography>
                                
                                <form onSubmit={handleSubmitnotify}>
                                    <Stack spacing={2.5}>
                                        <Box>
                                            <Typography variant="caption" fontWeight="800" color="text.secondary" sx={{ mb: 0.5, display: 'block', textTransform: 'uppercase' }}>{t("code_promo")}</Typography>
                                            <TextField name="code" defaultValue={promo.code} required sx={{...textFieldSx, '& .MuiInputBase-input': { ...textFieldSx['& .MuiInputBase-input'], textTransform: 'uppercase' }}} fullWidth />
                                        </Box>
                                        
                                        <Box>
                                            <Typography variant="caption" fontWeight="800" color="text.secondary" sx={{ mb: 0.5, display: 'block', textTransform: 'uppercase' }}>USER NHẬN MÃ</Typography>
                                            <Autocomplete
                                                options={users}
                                                getOptionLabel={(option) => option.username === 'all' ? 'Tất cả mọi người (all)' : `${option.username} - ${option.name}`}
                                                value={selectedUserEdit}
                                                onChange={(event, newValue) => { setSelectedUserEdit(newValue); }}
                                                sx={{
                                                    // Bổ sung lề phải để mũi tên Dropdown có chỗ trống
                                                    '& .MuiOutlinedInput-root': { paddingRight: '39px !important' }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} placeholder="Tìm tên đăng nhập..." sx={{...textFieldSx, '& .MuiInputBase-input': { ...textFieldSx['& .MuiInputBase-input'], textTransform: 'none' }}} />
                                                )}
                                                componentsProps={{ 
                                                    popper: { sx: { zIndex: 10000 } },
                                                    paper: { sx: { borderRadius: '8px', mt: 1, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', '& .MuiAutocomplete-listbox': { fontSize: '0.9rem', fontWeight: 600 } } } 
                                                }}
                                            />
                                        </Box>

                                        <Box>
                                            <Typography variant="caption" fontWeight="800" color="text.secondary" sx={{ mb: 0.5, display: 'block', textTransform: 'uppercase' }}>{t("code_uses")} (SỐ LƯỢT ĐANG CÒN)</Typography>
                                            <TextField name="num" defaultValue={promo.num} type="number" required sx={{...textFieldSx, '& .MuiInputBase-input': { ...textFieldSx['& .MuiInputBase-input'], textTransform: 'none' }}} fullWidth />
                                        </Box>

                                        <Box>
                                            <Typography variant="caption" fontWeight="800" color="text.secondary" sx={{ mb: 0.5, display: 'block', textTransform: 'uppercase' }}>{t("money")} (GIÁ TRỊ)</Typography>
                                            <TextField name="money" defaultValue={promo.money} type="number" required sx={{...textFieldSx, '& .MuiInputBase-input': { ...textFieldSx['& .MuiInputBase-input'], textTransform: 'none' }}} fullWidth />
                                        </Box>
                                        
                                        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={2}>
                                            <Button variant="outlined" color="inherit" onClick={() => setShow(false)} sx={{ fontWeight: 800, px: 3, borderRadius: '8px' }}>
                                                {t("close")}
                                            </Button>
                                            <Button variant="contained" color="primary" type="submit" sx={{ fontWeight: 800, px: 4, borderRadius: '8px', boxShadow: 'none' }}>
                                                {t("submit")}
                                            </Button>
                                        </Stack>
                                    </Stack>
                                </form>
                            </Card>
                        </Box>
                    )}
                </ThemeProvider>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default Promo;